export default __webpack_public_path__ + "static/free-course-seo-e2c5e67f4919c9da77da2c8cfec5a3e1.jpg";